import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFieldArray, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { branch } from "../../validations/Validation";
import { postBranch } from "../../services/post.service";
import { toast } from "react-toastify";

export interface IUseCreateBranch {
  onSubmit: (data: any) => void;
  registerGeneral: any;
  registerAddress: any;
  unRegisterAddress: any;
  handleSubmitGeneral: any;
  handleSubmitAddress: any;
  errorsGeneral: any;
  errorsAddress: any;
  formValue: any;
  setFormValue: any;
  addressFields: any;
  appendAddress: any;
  addressRemove: any;
  loading: boolean;
}

export const useCreateBranch = (): IUseCreateBranch => {
  const [formValue, setFormValue] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);
  const naviagte = useNavigate();

  const onSubmit = () => {
    setLoading(true);
    var id = toast.loading("Please wait...", {
      theme: "colored",
      type: "info",
      closeButton: true,
    });

    postBranch(formValue)
      .then((res) => {
        toast.update(id, {
          render: res.data,
          type: "success",
          theme: "colored",
          autoClose: 2500,
          isLoading: false,
          closeOnClick: true,
          hideProgressBar: false,
        });
        
        setLoading(false);
        naviagte("/branches");
      })
      .catch((err) => {
        toast.update(id, {
          render: err?.response?.data?.detail,
          theme: "colored",
          autoClose: 5000,
          type: "error",
          isLoading: false,
          closeOnClick: true,
          hideProgressBar: false,
        });
        setLoading(false);
        console.log(err);
      });
  };

  const {
    register: registerGeneral,
    handleSubmit: handleSubmitGeneral,
    control,
    formState: { errors: errorsGeneral },
  } = useForm({
    resolver: yupResolver(branch),
    defaultValues: { addresses: formValue.addresses },
  });

  const {
    register: registerAddress,
    handleSubmit: handleSubmitAddress,
    unregister: unRegisterAddress,
    formState: { errors: errorsAddress },
  } = useForm();

  const {
    fields: addressFields,
    append: addressAppend,
    remove: addressRemove,
  } = useFieldArray({
    control,
    name: "addresses",
  });

  const appendAddress = () => {
    addressAppend({});
  };

  return {
    onSubmit,
    formValue,
    setFormValue,
    registerGeneral,
    handleSubmitGeneral,
    errorsGeneral,
    registerAddress,
    handleSubmitAddress,
    unRegisterAddress,
    errorsAddress,
    appendAddress,
    addressFields,
    addressRemove,
    loading,
  };
};
